// apps/web/src/views/auth-views/authentication/login/index.js

import React from 'react'
import LoginForm from '../../components/LoginForm'
import { Card, Row, Col, Typography } from 'antd'
import { useSelector } from 'react-redux'

const { Title, Text } = Typography

const backgroundStyle = {
  backgroundImage: 'url(/img/others/img-17.jpg)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}

const Login = (props) => {
  const theme = useSelector((state) => state.theme.currentTheme)

  return (
    <div
      className="h-100"
      style={{
        ...backgroundStyle,
        minHeight: '100vh',
      }}
    >
      <div className="container d-flex flex-column justify-content-center h-100">
        <Row justify="center">
          <Col xs={22} sm={20} md={14} lg={8} xl={7}>
            <Card
              bordered={false}
              style={{
                borderRadius: 18,
                boxShadow: '0 24px 70px rgba(0, 0, 0, 0.18)',
              }}
              bodyStyle={{
                padding: '38px 34px',
              }}
            >
              <div>
                <div
                  className="text-center"
                  style={{
                    marginBottom: 30,
                  }}
                >
                  <img
                    className="img-fluid"
                    src={`/img/${
                      theme === 'light'
                        ? 'logo.png'
                        : 'logo-white.png'
                    }`}
                    alt="NLB Soluções"
                    style={{
                      maxWidth: 220,
                      maxHeight: 90,
                      objectFit: 'contain',
                    }}
                  />

                  <Title
                    level={3}
                    style={{
                      marginTop: 20,
                      marginBottom: 6,
                    }}
                  >
                    Acesso à plataforma
                  </Title>

                  <Text type="secondary">
                    Entre com seu e-mail e senha
                  </Text>
                </div>

                <Row justify="center">
                  <Col xs={24} sm={24} md={22} lg={22}>
                    <LoginForm {...props} />
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Login